module.exports = __webpack_public_path__ + "img/tabler-icon-users.fa6e5226.svg";